import { Injectable } from '@angular/core';
import { AuthFormUser, AuthUser } from '../models/auth.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private user: AuthUser;

  constructor(private http: HttpClient) { }

  public login(body: AuthFormUser): Observable<any> {
    const url = environment.apiSiteUrl + '/api/sites/login';
    return this.http.post<any>(url, body).pipe(
      tap((result) => {
        const authUser: AuthUser = {
          token: result.token.token,
          type: result.token.type,
          expires_at: result.token.expires_at,
          user: body,
        };
        this.user = this.setUserLogged(authUser);
      })
    );
  }

  // Not in use...
  // public getUserLogged() {
  //   const item = localStorage.getItem('user');
  //   console.log('item', item);
  //   this.user = item ? JSON.parse(item) : undefined;
  //   // this.user = item ? JSON.parse(atob(item)) : undefined;
  //   if (this.user !== undefined) {
  //     const validToken = this.isTokenExpired();
  //     this.user = validToken === false ? JSON.parse(item) : undefined;
  //   }
  //   if (this.user !== undefined) {
  //     return this.user;
  //   } else {
  //     return 'No hay ninguna sesión iniciada';
  //   }
  // }

  public isTokenExpired(siteUrl: string): boolean {
    // Local storage user item name (different for each site)
    const userItem = 'user_' + siteUrl;
    if (localStorage.getItem(userItem) === null) {
      return true;
    } else {
      const date = new Date();
      const item = localStorage.getItem(userItem);
      const user = JSON.parse(item);
      if (!user || date > new Date(user.expires_at)) {
        localStorage.removeItem(userItem);
        //todo localStorage.removeItem('path');
        return true;
      }
      return false;
    }
  }

  private setUserLogged(user: AuthUser) {
    // Set local storage user item name (different for each site)
    const userItem = 'user_' + user.user.site;
    if (user.token) {
      localStorage.setItem(
        userItem,
        // btoa(
        JSON.stringify({
          user: { username: user.user.username, site: user.user.site },
          expires_at: user.expires_at,
          token: user.token,
          type: user.type,
        })
        // )
      );
    }
    return user;
  }
}
